import { render, staticRenderFns } from "./KanbanBoardInsights.vue?vue&type=template&id=731626dc&scoped=true&"
import script from "./KanbanBoardInsights.vue?vue&type=script&lang=js&"
export * from "./KanbanBoardInsights.vue?vue&type=script&lang=js&"
import style0 from "./KanbanBoardInsights.vue?vue&type=style&index=0&id=731626dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731626dc",
  null
  
)

export default component.exports